export default {"src":"/uk/_next/static/media/pastPerformanceIcon.0d90bab2.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};